import { render, staticRenderFns } from "./ClearanceRequests.vue?vue&type=template&id=3df9eaf7&scoped=true"
import script from "./ClearanceRequests.vue?vue&type=script&lang=js"
export * from "./ClearanceRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df9eaf7",
  null
  
)

export default component.exports